<template>
  <div class="formMaking-content">
    <el-dialog :visible.sync="dialogVisible" width="1080px" title="表单生成" class="formMaking-dialog"
      @close="formDialogClose" @open="formDialogOpen">
      <fm-making-form ref="generateForm" :data="jsonData" :value="values">
        <template slot="action"></template>
      </fm-making-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" @click="preview">预览</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="previewVisible" width="420px" title="表单预览" class="preview-dialog"
      :close-on-click-modal="false" :show-close="false">
      <div>
        <div v-for="(item,index) in labelList" :key="index">
          <div v-if="item.type=='radio'">
            <label for="" class="form-label">{{item.name}}:</label>
            <span v-for="(raItem,raIndex) in item.options.options" :key="raIndex">
              <label for="">{{raItem.label}}</label>
              <input type="radio" :name="item.name" :value="raIndex" class="checkInput"></input>
            </span>
          </div>
          <div v-if="item.type=='textarea'">
            <label for="" class="form-label">{{item.name}}:</label>
            <textarea name="" id="" cols="40" rows="5"></textarea>
          </div>
          <div v-if="item.type=='checkbox'">
            <label for="" class="form-label">{{item.name}}:</label>
            <span v-for="(checkItem,checkIndex) in item.options.options" :key="checkIndex">
              <label for="">{{checkItem.value}}</label>
              <input type="checkbox" :name="item.name" :value="checkIndex" class="checkInput"></input>
            </span>
          </div>
          <div v-if="item.type=='date'">
            <label for="" class="form-label">{{item.name}}:</label>
            <input type="date" :value="item.options.defaultValue"></input>
          </div>
          <div v-if="item.type=='select'">
            <label for="" class="form-label">{{item.name}}:</label>
            <select :name="item.name" id="">
              <option :value="option.value" v-for="(option,optionIndex) in item.options.options" :key="optionIndex">{{option.value}}</option>
            </select>
          </div>
          <div v-if="item.type=='input'">
            <label for="" class="form-label">{{item.name}}:</label>
            <input type="text">{{item.options.defaultValue}}</input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="previewVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    props: ['initData', 'isShow'],
    data() {
      return {
        dialogVisible: false,
        previewVisible: false,
        jsonData: {}, // 表单配置中生成的json数据
        values: {}, // 表单需要显示的表单数据
        formContent: '',
        labelList: [],
      };
    },
    watch: {
      isShow: function (newVal, oldVal) {
        this.dialogVisible = true;
        setTimeout(() => {
          this.setData();
        }, 500);
      }
    },
    methods: {
      // 弹窗关闭
      formDialogClose() {
        document.getElementsByClassName('iframe-content')[0].style.height =
          '100%';
      },
      // 弹框关闭
      formDialogOpen() {
        document.getElementsByClassName('iframe-content')[0].style.height = '0';
      },
      // 初始化数据
      setData() {
        this.jsonData = this.initData !== '' ? JSON.parse(this.initData) : {};
        if (this.jsonData.list) this.$refs.generateForm.setJSON(this.jsonData);
      },
      // 预览
      preview() {
        console.log(this.$refs.generateForm.getJSON())
        this.previewVisible = true;
        this.labelList = this.$refs.generateForm.getJSON().list;
      },
      submit() {
        let data = {
          formMaking: this.$refs.generateForm.getJSON()
        };
        window.frames[0].postMessage(data, '*');
        this.dialogVisible = false;
      }
    }
  };
</script>
<style lang='less' scoped>
  .formMaking-content {
    height: 500px;

    .preview-dialog {
      text-align: left;
      .form-label {
        display: block;
        height: 14px;
        padding: 0;
        font-size: 14px;
        font-weight: 400;
        color: #999;
        line-height: 14px;
        margin:25px 0 6px;
      }
      select,
      input {
        width: 100%;
        height: 48px;
        margin-top: 8px;
        padding: 0 12px;
        line-height: 48px;
        border: 1px solid #ccc;
        border-radius: 4px;
        background: #fafafa;
      }
      textarea{
        width:100%;
        border: 1px solid #ccc;
        border-radius: 4px;
        background: #fafafa;
      }
      .checkInput{
        width:20px;
        height:20px;
        margin:0 20px 0 5px;
      }

    }
  }
</style>
<style lang='less'>
  .formMaking-content {

    .formMaking-dialog {
      .el-dialog__body {
        height: 600px;

        .fm2-container {
          height: 100% !important;
        }
      }
    }
    .el-dialog{
      border-radius: 10px;
    }
    .el-dialog__title{
      /* color: rgb(255, 102, 0); */
      font-size:16px;
    }

    .preview-dialog {
      .el-dialog{
        border-radius: 10px;
      }
      .el-dialog__body {
        padding:0px 20px 30px;
        height: 600px;
        border-bottom: 1px solid #e9eaec;
        border-top: 1px solid #e9eaec;
      }
    }
  }
</style>